import React from 'react'
import parser from 'html-react-parser'

export default function Content11({ data }) {
    const { content11List, content11Text, content11Title } = data
    return (
        <div className='dana-sec-2'>
            <div className='container'>
                <div className='dana-inr-sec-2 light-grey-bg'>
                    <div className='row'>
                        <div className='col-md-6 dana-sec-2-lt-sec'>
                            <h2 className='heading-level-2 blue-color'>{content11Title && parser(content11Title)}</h2>
                            <p>{content11Text && parser(content11Text)}</p>
                        </div>
                        <div className='col-md-6 green-dot-list'>
                            {content11List && parser(content11List)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
